export default {
    ux: {},
}